<template>
  <section :class="$style.container">
    <Wrapper>
      <Title :title-params="primary.title" :class="$style.title" />
      <RichText
        :text-params="primary.description"
        :class="$style.description"
      />
      <div :class="$style.itemsContainer">
        <div
          v-for="(item, itemIndex) in items"
          :key="itemIndex"
          :class="$style.item"
          data-aos="fade-up"
        >
          <Title :title-params="item.year" :class="$style.year" />
          <RichText
            :text-params="item.description"
            :class="$style.itemDescription"
          />
          <PLink
            v-if="item.cta_text && item.cta_link && item.cta_link.url"
            is-highlight
            color="bluko"
            :href="getFormatedLink(item.cta_link.url)"
            :class="$style.itemLink"
          >
            {{ item.cta_text }}
          </PLink>
        </div>
      </div>
    </Wrapper>
  </section>
</template>

<script>
import PLink from '~/components/PLink'
import { getFormatedLink } from '~/mixins/getFormatedLink'

export default {
  name: 'HighlightSectionDefault',
  components: {
    PLink,
  },
  mixins: [getFormatedLink],
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      primary: this.slice.primary,
      items: this.slice.items,
    }
  },
}
</script>

<style lang="scss" module>
.container {
  padding: 160px 32px 160px;
  @include below(small) {
    padding: 80px 16px;
  }
}
.title {
  max-width: 703px;
  margin: 0 auto;

  font-weight: 200;
  font-size: 48px;
  line-height: 58px;
  text-align: center;
  @include below(small) {
    font-size: 32px;
    line-height: 42px;
  }
}
.description {
  max-width: 950px;
  margin: 8px auto 0;

  text-align: center;
}

.itemsContainer {
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
  justify-content: space-evenly;
  margin-top: 64px;
}
.item {
  flex: 1;
  min-width: 220px;
  max-width: 400px;

  text-align: center;
}
.itemLink {
  display: inline-block;
  margin-top: 24px;
}
.year h2 {
  @include typo-extra-title;
}

.itemDescription {
  p {
    color: $gray-700;
  }
}
</style>
